export default "__VITE_ASSET__ODcbD$yG__"